import React from 'react';
import MediaQuery from 'react-responsive';

import './Values.css';

function ValuesSection() {
  return (
    <div id="values">
      <MediaQuery query="(min-width: 425px)">
        <div className="half" />
      </MediaQuery>

      <div className="half" id="right">
        <div id="value">
          <h1>
            Innovation
            <span>.</span>
          </h1>
          <div className="halfUnderline" />
          <p>
            Research applied to real products
            <br />
            developed with industry and
            <br />
            academic partners.
          </p>
        </div>

        <div id="value">
          <h1>
            Technology
            <span>.</span>
          </h1>
          <div className="halfUnderline" />
          <p>
            Based in cutting-edge research
            <br />
            related to visualization, tracking and
            <br />
            natural interaction.
          </p>
        </div>

        <div id="value">
          <h1>
            Multidisciplinarity
            <span>.</span>
          </h1>
          <div className="halfUnderline" />
          <p>
            Multidisciplinary group exploring
            <br />
            augmented reality applications in
            <br />
            areas such as health and education.
          </p>
        </div>
      </div>

    </div>
  );
}

export default ValuesSection;
